import { cn } from "@/lib/utils";
import { TONE_PILL } from "@/lib/widget-status";
import { CUSTOMER_STATUS_LABELS, customerStatusTone, type CustomerStatus } from "@/lib/customer-status";

interface CustomerStatusPillProps {
  status: CustomerStatus;
  className?: string;
  /** Heroen på kundekortet: ThrashPunks-skrift som i styleguiden. Fargen er fortsatt semantisk. */
  punk?: boolean;
}

/** Varm/Medium/Kald som pill. Fargene kommer fra widget-status (semantisk KPI-palett). */
export default function CustomerStatusPill({ status, className, punk = false }: CustomerStatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill px-3 py-0.5 font-medium",
        punk ? "font-punk text-[15px] leading-none py-1 px-3.5" : "text-[13px]",
        TONE_PILL[customerStatusTone(status)],
        className,
      )}
    >
      {CUSTOMER_STATUS_LABELS[status]}
    </span>
  );
}
